export const authorizedPa: string[] = [
  "ਅੰਬਾਲਾ",
  "ਅੰਬਾਲਾ-I"
]
